import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from "react";
export type ArtistPreviewTab = "active" | "winners";
export function useArtistPreviewModal() {
  const $ = _c(6);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("active");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = tab => {
      setActiveTab(tab);
      setIsModalOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleBadgeClick = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = tab_0 => {
      setActiveTab(tab_0);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleTabChange = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleModalClose = t2;
  let t3;
  if ($[3] !== activeTab || $[4] !== isModalOpen) {
    t3 = {
      isModalOpen,
      activeTab,
      handleBadgeClick,
      handleTabChange,
      handleModalClose
    };
    $[3] = activeTab;
    $[4] = isModalOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}